export default __webpack_public_path__ + "1ac311b286416d9dfeda438f236af50d.svg";